/* eslint-disable react/prop-types */
/* we can re-enable this when (if) AmazonLogin is ever revived (dead feature) */
/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react';
import t from '../../../lib/I18n';
import AmazonLoginStore from '../../../stores/AmazonLoginStore';
import BaseModal from '../../general/BaseModal';
import connectToStores from '../../../helpers/connectToStores';
import CustomerActions from '../../../actions/CustomerActions';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import ModalActions from '../../../actions/ModalActions';
import NotificationActions from '../../../actions/NotificationActions';
import UserChange from '../../../records/customer/UserChange';
import UserStore from '../../../stores/UserStore';

const _getStateFromStores = () => {
    return {
        amazonEmail: AmazonLoginStore.getAmazonEmail(),
        user: UserStore.getCurrent()
    };
};

class AmazonSyncEmailModal extends PureComponent {

    state = {
        form: new UserChange(this.props.user.customer.toJS()),
    }

    componentDidUpdate({ user: prevUser }) {
        const { amazonEmail, user } = this.props;
        const { form } = this.state;

        if (user && user !== prevUser) {
            this.setState({ form: form.merge({
                changeEmail: true,
                email: amazonEmail
            })});
        }
    }

    onClose = () => {
        ModalActions.close();
    };

    onContinue = async () => {
        const { amazonEmail, user } = this.props;
        const { form } = this.state;

        ModalActions.close();

        await CustomerActions.updateAuthenticatedProperties({
            user,
            changes: form.changes,
            requireAuth: false
        });
        NotificationActions.showNotification(`account.details.updated`);
    };

    render() {
        const modalProps = {
            className: 'modal--xs',
            closeText: t('login.syncEmail.amazon.closeText'),
            continueText: t('login.syncEmail.amazon.continueText'),
            onClose: this.onClose,
            onContinue: this.onContinue,
            titleText: t('login.syncEmail.amazon.title')
        };

        const { amazonEmail, customer } = this.props;

        return (<BaseModal { ...modalProps }>
            <section>
                <div className="text-center">
                    <p>
                        <FormattedHTMLMessage
                            message="login.syncEmail.amazon.message"
                            accountType={ t('app.owner.short') }
                            amazonEmail={ amazonEmail }
                            accountEmail={ customer.email } />
                    </p>
                </div>
            </section>
        </BaseModal>);
    }
}

export default connectToStores([AmazonLoginStore, UserStore], _getStateFromStores)(AmazonSyncEmailModal);



// WEBPACK FOOTER //
// ./src/components/login/amazon/AmazonSyncEmailModal.js